import { FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "@shared/api/gen";

export type IframeType =
	| "ok"
	| "vkplay"
	| "vkcom"
	| "fxid"
	| "yandex"
	| "ag"
	| "kg"
	| "fbgames"
	| "crazygames"
	| "ymobage"
	| "telegram"
	| "fxlauncher"
	| "fxnative"
	| "fbinstantgames"
	| "steam";

export const IframeTypeToSupportedPlatformMap: {
	[index in IframeType]: FxIdDomainStoreEnumsSupportedWebPublishingPlatform;
} = {
	ok: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Odnoklassniki,
	vkplay: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontaktePlay,
	vkcom: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontakteCom,
	fxid: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxId,
	yandex: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.YandexGames,
	ag: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.AbsoluteGames,
	kg: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Kongregate,
	fbgames: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FacebookGames,
	fbinstantgames: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FacebookInstantGames,
	crazygames: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.CrazyGames,
	ymobage: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.WizQ,
	telegram: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Telegram,
	fxlauncher: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxLauncher,
	fxnative: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxNative,
	steam: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Steam
};
export const SupportedPlatformToIframeTypeMap: {
	[index in FxIdDomainStoreEnumsSupportedWebPublishingPlatform]: IframeType;
} = {
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.AbsoluteGames]: "ag",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxId]: "fxid",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Kongregate]: "kg",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.NUMBER_unknown_default_open_api]: "fxid",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Odnoklassniki]: "ok",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Unspecified]: "fxid",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontakteCom]: "vkcom",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontaktePlay]: "vkplay",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.YandexGames]: "yandex",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FacebookGames]: "fbgames",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FacebookInstantGames]: "fbinstantgames",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.CrazyGames]: "crazygames",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.WizQ]: "ymobage",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Telegram]: "telegram",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxLauncher]: "fxlauncher",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxNative]: "fxnative",
	[FxIdDomainStoreEnumsSupportedWebPublishingPlatform.Steam]: "steam"
};
